export const INKSOFT_SESSION_TOKEN_KEY = "inksoftSessionToken";
export const INKSOFT_SESSION_TOKEN_UPDATED_EVENT = "inksoft:session-token-updated";

export function getStoredInksoftSessionToken(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(INKSOFT_SESSION_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function storeInksoftSessionToken(token: string): void {
  if (typeof window === "undefined") return;

  const normalizedToken = token.trim();
  if (!normalizedToken) return;

  try {
    window.localStorage.setItem(INKSOFT_SESSION_TOKEN_KEY, normalizedToken);
    window.dispatchEvent(
      new CustomEvent(INKSOFT_SESSION_TOKEN_UPDATED_EVENT, {
        detail: normalizedToken,
      })
    );
  } catch {
    // Ignore storage issues in restricted browsing modes.
  }
}
